import { render, staticRenderFns } from "./afterSale.vue?vue&type=template&id=b3101852&scoped=true&"
import script from "./afterSale.vue?vue&type=script&lang=js&"
export * from "./afterSale.vue?vue&type=script&lang=js&"
import style0 from "./afterSale.vue?vue&type=style&index=0&id=b3101852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3101852",
  null
  
)

export default component.exports